import parse from "html-react-parser";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  close,
  search as searchIcon,
  arrowLeft,
} from "../../assets/images/icons";
import { isMobile } from "../../bridges/BridgeServices";
import Header from "../../components/Header/header";

import "./search.scss";
import SearchResults from "../../components/SearchResults/searchResults";
import { navigate } from "gatsby";
import {
  getValueForQueryParam,
  isShowWebHeader,
} from "../../utils/helperFunctions";

const Search = ({ pageContext = {} }) => {
  const [input, setInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isInputFocus, setIsInputFocus] = useState(false);

  const handleInputChange = e => {
    const searchValue = e?.target?.value;
    setInput(searchValue);
    setIsInputFocus(true);
  };

  const queryParam =
    typeof window !== "undefined"
      ? getValueForQueryParam("q")
      : "";

  useEffect(() => {
    if (isMobile()) {
      document.getElementsByTagName("input")?.[0]?.focus();
      setIsInputFocus(true);
    }
  }, []);

  useEffect(() => {
    if (queryParam) {
      setSearchQuery(queryParam);
      setInput(queryParam);
    }
  }, [queryParam]);

  return (
    <>
      <Header
        title={"Search Page - Stock Faqs"}
        description={""}
        searchData={pageContext.searchDataArrayObject}
        inputData={searchQuery}
      />
      {isMobile() ? (
        <>
          {isShowWebHeader() ? (
            <div className={"mobile-search-container"}>
              <div
                className="back-arrow"
                onClick={() => {
                  navigate(-1);
                }}
              >
                {parse(arrowLeft)}
              </div>
              <input
                className={"input"}
                value={input}
                onChange={handleInputChange}
                placeholder={"Search for your queries"}
                data-testid={"search-input"}
              />

              <div
                className="close-icon"
                onClick={() => {
                  setInput("");
                }}
              >
                {parse(close)}
              </div>
            </div>
          ) : (
            <div
              className={`search-container ${
                isInputFocus
                  ? "mobile-container-focused"
                  : ""
              }`}
            >
              {parse(searchIcon)}
              <input
                className={"input"}
                value={input}
                onChange={handleInputChange}
                placeholder={"Search for your queries"}
                data-testid={"search-input"}
              />
              {input?.length ? (
                <div
                  className="close-icon"
                  onClick={() => {
                    setInput("");
                  }}
                >
                  {parse(close)}
                </div>
              ) : null}
            </div>
          )}

          <SearchResults
            data={pageContext.searchDataArrayObject}
            input={input}
            isSearchPage
          />
        </>
      ) : (
        <>
          <div className="search-page-wrapper">
            <div className="search-page-container">
              <SearchResults
                data={pageContext.searchDataArrayObject}
                input={input}
                isSearchPage
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

Search.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default Search;
